import { normalizeBaseUrl } from "shared-utils";
import { Api as LinkboardApi } from "../generated/LinkboardApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const linkboardApi = new LinkboardApi({
  baseURL: normalizeBaseUrl(config.linkboardApiUrl),
});

createAxiosRequestInterceptors(linkboardApi.instance);

export default linkboardApi;
